import React, { useState } from 'react';
import { View, Text, StyleSheet } from 'react-native';
import i18n from 'i18n-js';
import { connect } from 'react-redux';

import { scale } from '@components/frame';
import { isPhone } from '@helpers';

import { setMinimumTileSize } from '@reducers/machines';

import TouchableElement from '@components/common/touchableElement';

import { font } from '@styles/fonts';
import { getBoxShadowStyle } from '@styles/shadow';
import ColorsWrapper from '@styles/colors';
import LineSelector from '@components/common/lineSelector';
import { SCREEN_BORDER_RADIUS } from '@v2/pages/common/constants/base.constants';

const ChangeTileSize = ({ C, hide, machines: { minimumTileSize = 2 }, setMinimumTileSize }) => {
  const [selectedValue, setSelectedValue] = useState(minimumTileSize);

  const data = [
    {
      name: 'Extra Large',
      value: 4,
    },
    {
      name: 'Large',
      value: 3,
    },
    {
      name: 'Default',
      value: 2,
    },
    {
      name: 'Small',
      value: 1,
    },
  ];

  return (
    <View style={{ paddingBottom: scale(20), paddingHorizontal: isPhone ? 0 : scale(15) }}>
      <View>
        <View
          style={{
            width: '100%',
            zIndex: 1000,
            height: scale(58),
          }}
        >
          <View style={{ position: 'absolute', zIndex: 1000, right: 0 }}>
            <TouchableElement
              onPress={() => {
                setMinimumTileSize(selectedValue);
                hide();
              }}
            >
              {({ boxStyle, pressHoverColor }) => (
                <View style={[boxStyle, { padding: scale(15), paddingHorizontal: isPhone ? scale(15) : 0, flexDirection: 'row' }]}>
                  <Text style={[{ color: C(pressHoverColor('System/Light/Blue')), marginLeft: scale(7) }, font['Button 1']]}>{i18n.t('Done')}</Text>
                </View>
              )}
            </TouchableElement>
          </View>
        </View>
        <View style={{ width: '100%', position: 'absolute', zIndex: 100, top: scale(15) }}>
          <Text style={[{ color: C('Label/Light/Primary'), width: '100%', textAlign: 'center' }, font.Headline]}>{i18n.t('Minimum Tile Size')}</Text>
        </View>
      </View>
      <View style={{ marginTop: scale(20), paddingHorizontal: scale(15) }}>
        <Text style={[{ color: C('Label/Light/Tertiary') }, font.Footnote]}>{i18n.t('SELECT MINIMUM TILE SIZE')}</Text>
      </View>
      <View
        style={[
          getBoxShadowStyle({ type: 'Field', C }),
          { marginTop: scale(5), borderRadius: scale(SCREEN_BORDER_RADIUS) },
          isPhone && {
            borderColor: C('Hairline/Light/No trans'),
            borderBottomWidth: StyleSheet.hairlineWidth,
            borderTopWidth: StyleSheet.hairlineWidth,
          },
        ]}
      >
        {data.map((item, index) => (
          <LineSelector
            key={item.value}
            {...{
              C,
              onPress: () => setSelectedValue(item.value),
              text: item.name,
              borderRadiusTop: isPhone ? false : index === 0,
              borderRadiusBottom: isPhone ? false : index === data.length - 1,
              shadow: false,
              borderBottom: index !== data.length - 1,
              selected: selectedValue === item.value,
            }}
          />
        ))}
      </View>
    </View>
  );
};

const mapStateToProps = ({ machines }) => ({ machines });

export default connect(mapStateToProps, { setMinimumTileSize })(ColorsWrapper(ChangeTileSize));
